import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import css from './MerchantFullCalendarEventContent.module.scss';
import BookingEvent, {
  FullCalendarViewStyle as ViewStyle,
} from '../../../../domain/entities/BookingEvent';

const intlPref = 'merchants.services.merchantFullCalendarEventContent.';

interface ComponentProps {
  bookingEvent: BookingEvent;
  viewType: string;
  title: string;
  timeText: string;
  textColor: string;
}

type Props = ComponentProps;

// use only when fully booked
const MerchantFullCalendarEventContent = ({
  bookingEvent,
  viewType,
  textColor,
  title,
  timeText,
}: Props) => {
  const intl = useIntl();
  const isDayGridMonth = viewType === ViewStyle.dayGridMonth;
  const isListMonth = viewType === ViewStyle.listMonth;
  const classes = classNames(css.MerchantFullCalendarEventContent, {
    [css.isDayGridMonth]: isDayGridMonth,
    [css.isListMonth]: isListMonth,
  });
  const style = {
    color: isListMonth ? '#000' : textColor,
  };
  return (
    <div className={classes} style={style}>
      <div className={css.MerchantFullCalendarEventContent__Status}>
        {intl.formatMessage({
          id: intlPref + 'status.soldOut',
        })}
      </div>
      <div
        className={css.MerchantFullCalendarEventContent__DescriptionContainer}
      >
        {!bookingEvent.isAllDay && (
          <div className={css.MerchantFullCalendarEventContent__StartTime}>
            {timeText}
          </div>
        )}
        <div className={css.MerchantFullCalendarEventContent__Description}>
          {title}
        </div>
      </div>
    </div>
  );
};

export default MerchantFullCalendarEventContent;
